'use client';

import { type ReactNode, useEffect } from 'react';

import { ERROR_PAGE_ATTRIBUTE } from '@/app/contents/errors';

interface ErrorPageWrapperProps {
  children: ReactNode;
}

export const ErrorPageWrapper = ({ children }: ErrorPageWrapperProps) => {
  useEffect(() => {
    document.body.setAttribute(ERROR_PAGE_ATTRIBUTE, 'true');

    return () => {
      document.body.removeAttribute(ERROR_PAGE_ATTRIBUTE);
    };
  }, []);

  return <>{children}</>;
};
